export default "__VITE_ASSET__37c57863__"